import EditorialImage from 'components/EditorialImage';
import React from 'react';
import { PortableText } from '@portabletext/react';
import { urlForPortableImage } from 'services/server/sanity/components/Image';
import NewsLetterForm from 'components/Website/NewsLetter/Form';
import {
  emailPortableTextMarks,
  linkEmailAddresses,
  renderEmailAddresses,
} from 'components/EmailLink/richText';

// The same approved editorial components render in articles, FAQs, OPC and lessons.
export const editorialPortableComponents = {
  types: {
    image: ({ value }: any) => (
      <EditorialImage
        src={urlForPortableImage(value).url()}
        alt={value.alt || ''}
        width={value.localizedAsset?.width}
        height={value.localizedAsset?.height}
        crop={value.crop}
        hotspot={value.hotspot}
      />
    ),
    table: ({ value }: any) => (
      <table>
        <tbody>
          {(value.rows || []).map((row: any, index: number) => (
            <tr key={row._key || index}>
              {row.cells.map((cell: string, column: number) =>
                index === 0 ? (
                  <th key={column}>{renderEmailAddresses(cell)}</th>
                ) : (
                  <td key={column}>{renderEmailAddresses(cell)}</td>
                ),
              )}
            </tr>
          ))}
        </tbody>
      </table>
    ),
    newsletterCta: () => <NewsLetterForm />,
  },
  marks: emailPortableTextMarks,
};

export default function EditorialPortableText(props: any) {
  return (
    <PortableText
      components={editorialPortableComponents}
      {...props}
      value={linkEmailAddresses(props.value)}
    />
  );
}
